import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};


class DefaultFooter extends Component {

  ManualUpdateclick = async () => {
    var HosName = await localStorage.getItem('HosName')
    var formData = new FormData();
    await formData.append('Hospital',HosName)
    await Axios.post("https://task-process-rama.et.r.appspot.com/update",formData,).then( res =>{
      res.header('Access-Control-Allow-Origin', '*');
      console.log("Success")
    }
    )
    await alert ("Manual Update")
  }
  
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    const IsAdmin = localStorage.getItem('ADMINSTATUS')
    const AdminButton = () => { 
      return (
      <button onClick={this.ManualUpdateclick} left='true'  className="fa fa-asterisk" >
          </button>
      )
    }
    

    return (
      <React.Fragment>
          {IsAdmin === 'Yes' ? AdminButton():null}
        <span className="ml-auto">Organized by Faculty of Medicine Ramathibodi Hospital</span>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultFooter.js